import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-admin-status-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-status-badge.component.html',
  styleUrl: './admin-status-badge.component.scss',
})
export class AdminStatusBadgeComponent {
  @Input() limited = false;

  get label(): string {
    return this.limited ? 'Limitada' : 'Ativa';
  }
}
